<template>
  <iframe
    title="Map of the property neighborhood"
    width="100%"
    height="500"
    style="border:0; display:block; padding:0; margin:0;"
    :src="
      `https://www.google.com/maps/embed/v1/place?key=` +
        options.rentpress_google_maps_api_section_api_key +
        `&zoom=15&q=` +
        property.property_name +
        `,` +
        property.property_address +
        `,` +
        property.property_city +
        `,` +
        property.property_state
    "
  />
</template>

<script>
export default {
  props: {
    property: Object,
    options: Object
  }
};
</script>
